import React from "react";

// TODO: refactor this approach to animation - it works but was a quick development
const effect1Start = {
  overlayOpacity: 0,
  modalTransition: {
    opacity: 0,
    transform: "translate(-50%, -50%) scale(0.7)"
  }
};

const effect1End = {
  overlayOpacity: 0.7,
  modalTransition: {
    opacity: 1,
    transform: "translate(-50%, -50%) scale(1)"
  }
};

class Modal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      start: {
        ...effect1Start,
        next: "stop"
      },
      stop: {
        ...effect1End,
        next: "start"
      },
      stay: {
        ...effect1End,
        next: "stay"
      },
      current: this.props.current || "start"
    };
  }

  componentDidMount() {
    this.body = document.getElementsByTagName("body")[0];
    this.body.classList["add"]("overflow-hidden");
    document.addEventListener("keyup", this.handleEscapeKey);
    setTimeout(() => this.animateOnEntry(), 1);
  }

  componentWillUnmount() {
    this.body.classList["remove"]("overflow-hidden");
    document.removeEventListener("keyup", this.handleEscapeKey);
  }

  animateOnEntry = () => {
    this.setState(({ current, ...state }) => ({
      current: state[current].next
    }));
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.closing) {
      this.setState({ current: "start" });
    }
  }

  handleEscapeKey = event => {
    if (event.key === "Escape") {
      this.props.close();
    }
  };

  render() {
    const {
      width,
      height,
      close,
      closing,
      processing = false,
      children
    } = this.props;
    const { current, ...state } = this.state;
    return (
      <div>
        <div
          className="fixed relative top-0 left-0 w-100 vh-100 bg-black z-7_9"
          style={{
            backFaceVisibility: "hidden",
            transition: "all 0.3s",
            opacity: state[current].overlayOpacity
          }}
          onClick={close}
        />
        <div
          className="fixed bg-white z-7_9 overflow-y-scroll w-100 w-60-ns"
          style={{
            maxHeight: height,
            maxWidth: width,
            height: "88vh",
            top: "50%",
            left: "50%",
            backFaceVisibility: "hidden",
            transition: "all 0.3s",
            ...state[current].modalTransition
          }}
        >
          {processing && (
            <div
              className="absolute w-100 h-100 bg-white-70 flex items-center justify-center"
              style={{ zIndex: 9999999 }}
            >
              <img src="/images/webreader/page-spinner.svg" alt="" />
            </div>
          )}

          <a
            href={EMPTY_HREF}
            onClick={close}
            className="absolute db top-0 right-0 t-ma2 z-7_9"
          >
            <img
              src="/images/pop-rate-modal-close.png"
              alt="close"
              width="16px"
              height="16px"
            />
          </a>
          <div className="t-ph2 t-pt4 t-pb3 relative">{children}</div>
        </div>
      </div>
    );
  }
}

Modal.defaultProps = {
  width: "50%",
  height: "80%"
};

export default Modal;
